//NEW: UI_REVAMP
import { Box, Flex, Text } from '@chakra-ui/react';
import { ReactComponent as BetList } from '../../assets/svg/list.svg';
import { useBettingScreen } from '../../hooks/useStore';
import { BetResultScreen } from '../../screen/BetResultScreen';
import GradientBox from '../box/GradientBox';
import ActionButton from '../button/ActionButton';
import Header from '../Header/Header';
import BetNumberSelectors from '../keyboard/BetNumberSelectors';
import EnterPriceKeypad from '../keyboard/EnterPriceKeypad';
import BettingControls from './BettingControls';
import BettingList from './BettingList';

const BettingDesktopView = ({
	showBetList,
	activeBetTab,
	setActiveBetTab,
	activeSiteType,
	setActiveSiteType,
	getDraw,
	getGame,
	time,
	setTime,
	timeBtnId,
	setTimeBtnId,
	timeName,
	setTimeName,
	serverTime,
	activeBetType,
	setActiveBetType,
	handleLucky,
	handleEz2Add,
	setShowBetList,
	swer3Selection,
	ez2Selection,
	handleDigitClick,
	handleAddToList,
	handleBet2SwerAdd,
	handleBet2EzAdd,
	handleBet3Add,
	onOpenCheckout,
	betting,
	removeBetting,
	removeAllByDigit,
	gameId,
	setIsLuckyPick,
	isDisabled,
	isSelectionIncomplete,
	invalidBetIds,
	setInvalidBetIds,
}) => {
	const results = useBettingScreen((state) => state.results);

	return (
		<Flex w={{ lg: 'full' }} h='full' flexDirection='column' gap={4}>
			<Header display={results ? { base: 'none', lg: 'block' } : 'none'} />
			{results ? (
				<BetResultScreen />
			) : (
				<Flex w='full' h='full' display={{ base: 'none', lg: 'flex' }} gap={4}>
					{/* Left panel */}
					<Flex direction='column' w={showBetList ? '63%' : 'full'} h='full' minH='0' gap={2}>
						<BettingControls
							activeBetTab={activeBetTab}
							setActiveBetTab={setActiveBetTab}
							activeSiteType={activeSiteType}
							setActiveSiteType={setActiveSiteType}
							getDraw={getDraw}
							getGame={getGame}
							time={time}
							setTime={setTime}
							timeBtnId={timeBtnId}
							setTimeBtnId={setTimeBtnId}
							timeName={timeName}
							setTimeName={setTimeName}
							serverTime={serverTime}
							activeBetType={activeBetType}
							setActiveBetType={setActiveBetType}
							handleLucky={handleLucky}
							handleEz2Add={handleEz2Add}
							showBetList={showBetList}
							setShowBetList={setShowBetList}
						/>
						<Flex
							p={2}
							flexDirection='column'
							gap={2}
							flex='1'
							minH='0'
							bgGradient='radial-gradient(46.23% 63.98% at 50.14% 100%, #C1B5FE 0%, rgba(255, 255, 255, 0.00) 100%), linear-gradient(181deg, #F3F1FF 50%, #CEC9FF 99.47%)'
							boxShadow='0 0 10px 0 rgba(165, 193, 241, 0.50)'
							h='full'
							borderRadius={16}
							overflowY='auto'
						>
							<BetNumberSelectors
								activeBetTab={activeBetTab}
								activeSiteType={activeSiteType}
								swer3Selection={swer3Selection}
								ez2Selection={ez2Selection}
								onDigitClick={handleDigitClick}
								onAddToListSwer={handleBet2SwerAdd}
								onAddToListEz={handleBet2EzAdd}
								onAddToListBet3={handleBet3Add}
								betting={betting}
								removeBetting={removeBetting}
								removeAllByDigit={removeAllByDigit}
								gameId={gameId}
								drawId={timeBtnId}
								activeBetType={activeBetType}
								onManualInteract={() => setIsLuckyPick(false)}
								isSelectionIncomplete={isSelectionIncomplete}
								isDisabled={isDisabled}
							/>
							{(activeBetTab === 'bet1' ||
								(activeBetTab === 'bet2' && activeSiteType === 1) ||
								(activeBetTab === 'bet3' && activeSiteType === 1)) && (
								<Box p={2}>
									<ActionButton
										onClick={handleAddToList}
										isDisabled={isDisabled || isSelectionIncomplete}
									>
										<BetList size={16} />
										<Text as='span'>Add to Bet List</Text>
									</ActionButton>
								</Box>
							)}
						</Flex>
					</Flex>

					{/* Right panel */}
					{showBetList && (
						<Flex direction='column' flex='1' minH='0' gap={2}>
							<GradientBox variant='purpleWhite' flex='1' minH='0' borderRadius={16}>
								<Flex
									flexDirection='column'
									pt={2}
									pb={0}
									bg='white'
									h='full'
									borderRadius={16}
									spacing={0}
								>
									<Box py={1} px={2}>
										<Text fontWeight={600} fontSize='14px'>
											Bet Lists
										</Text>
									</Box>

									<BettingList
										getGame={getGame}
										invalidBetIds={invalidBetIds}
										setInvalidBetIds={setInvalidBetIds}
									/>
								</Flex>
							</GradientBox>

							{!results && (
								<GradientBox h='222px' borderRadius={16} variant='purpleWhite'>
									<Box
										bg={isDisabled ? 'rgba(238, 233, 254, 1)' : 'rgba(238, 233, 254, 0.50)'}
										h='full'
										borderRadius={16}
										py={4}
										px={2}
									>
										<EnterPriceKeypad
											activeBetTab={activeBetTab}
											onClick={onOpenCheckout}
											onClose={() => {}}
											isDisabled={betting.length === 0}
										/>
									</Box>
								</GradientBox>
							)}
						</Flex>
					)}
				</Flex>
			)}
		</Flex>
	);
};

export default BettingDesktopView;
